<script setup lang="ts">
import { useFavoritesStore } from '@/stores/favorites'
const favoritesStore = useFavoritesStore();
import CustomButton from "@/components/Button/Button.vue";
import {useYachtStore} from "@/stores/yachtStore";
import {ref, watch} from "vue";

const emit = defineEmits(['inquire'])

function inquireYachts() {
  emit('inquire')
}

const yachtStore = useYachtStore();

const showEmptyMessage = ref(false);

</script>

<template>
  <el-dropdown-menu>
    <!-- Scrollable Yacht List Container -->
    <div class="max-h-60 overflow-y-auto px-4 py-2">
      <el-dropdown-item
          v-for="yacht in favoritesStore.favorites"
          :key="yacht.id"
          class="!p-0 hover:bg-transparent"
      >
        <div class="flex justify-between items-center py-2 px-2">
          <div
              class="flex items-center gap-4 cursor-pointer"
              @click="yachtStore.viewYachtDetails(yacht.slug)"
          >
            <img
                :src="yacht?.images.length > 0 ? yacht?.images[0]['original'] : yacht?.image_main['original']"
                 alt="Yacht image"
                class="w-20 h-20 object-cover flex-shrink-0"
            />
            <div class="flex flex-col">
              <span class="font-bold responsive-body-medium text-primary-darkBlue">{{ yacht.name }}</span>
              <span class="responsive-body-xsmall text-bw-midGrey uppercase">{{ yacht.category }}</span>
            </div>
          </div>

          <button
              @click.stop="favoritesStore.removeFavorite(yacht.id)"
              class="ml-10 hover:text-red-600 focus:outline-none"
          >
            ✕
          </button>
        </div>
      </el-dropdown-item>

      <el-dropdown-item v-if="favoritesStore.favorites.length === 0" disabled>
        No favorites yet.
      </el-dropdown-item>
    </div>

    <div v-show="favoritesStore.favorites.length > 0" class="px-4 py-3 bg-white sticky bottom-0 z-10">
      <CustomButton type="red" size="medium" class="py-2 w-full" @click="inquireYachts">
        ENQUIRE ALL YACHTS
      </CustomButton>
    </div>
  </el-dropdown-menu>
</template>



